import HTTP from './libs/HTTP';

class AuthService extends HTTP {

    async login(adminAcc: string, adminPwd: string) {
      const response = await this.post('/login', {
        account: adminAcc,
        password: adminPwd,
      }, { withCredentials: true });
      return response;
    }
  
    async logout() {
      const response = await this.post('/logout', {});
      return response;
    }
}
export default new AuthService();
